import { render } from "./CoverSection.vue?vue&type=template&id=07af0066&scoped=true"
import script from "./CoverSection.vue?vue&type=script&lang=js"
export * from "./CoverSection.vue?vue&type=script&lang=js"

import "./CoverSection.vue?vue&type=style&index=0&id=07af0066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07af0066"]])

export default __exports__